<script></script>
<template>
  <div
    class="simulation-notification alert-model alert-warning mx-0 px-4 d-flex justify-content-between align-items-center"
  >
    <div class="font-weight-bold">
      <slot></slot>
    </div>
    <div v-if="$slots.buttons">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>
